import {AbstractControl, ValidatorFn} from '@angular/forms';

export class NumeriqueValidator {

	/**
	 * Vérifie que la valeur du champ est null ou strictement supérieure a une valeur donnée
	 *
	 * @param nombre nombre dont il faut etre strictement supérieur
	 */
	static superieurStrictement(nombre: number): ValidatorFn {
		return (control: AbstractControl): { [key: string]: boolean } | null => {
			if (!control.parent) {
				return null;
			}
			const valeur = parseFloat(control.value);
			// on est pas valide si la valeur est inférieur ou égale au nombre.
			if (!Number.isNaN(valeur) && valeur <= nombre) {
				return {'superieurStrictement': true};
			}
			return null;
		};
	}

	/**
	 * Vérifie que la valeur du champ est null ou supérieure ou égale a une valeur donnée
	 *
	 * @param nombre nombre dont il faut être supérieur ou égale
	 */
	static superieurOuEgal(nombre: number): ValidatorFn {
		return (control: AbstractControl): { [key: string]: boolean } | null => {
			if (!control.parent) {
				return null;
			}
			const valeur = parseFloat(control.value);
			// on est pas valide si la valeur est strictement inférieur au nombre.
			if (!Number.isNaN(valeur) && valeur < nombre) {
				return {'superieurOuEgal': true};
			}
			return null;
		};
	}

	/**
	 * Validation que le control est bien un numérique
	 *
	 * @param formControl le formcontrol
	 */
	static numeric(formControl: AbstractControl) {
		const numberRegex = /^[-+]?([0-9]+)$/;
		return NumeriqueValidator.validateNumberRegex(formControl, numberRegex);
	}

	/**
	 * Validation que le control est bien un numérique supérieur ou égale à 0
	 *
	 * @param formControl le formcontrol
	 */
	static numericZeroOuPositif(formControl: AbstractControl) {
		const numberRegex = /^([0-9]+)$/;
		return NumeriqueValidator.validateNumberRegex(formControl, numberRegex);
	}

	/**
	 * Validation que le control est bien un numérique strictement supérieur à 0
	 *
	 * @param formControl le formcontrol
	 */
	static numericPositif(formControl: AbstractControl) {
		const numberRegex = /^[0-9]*[1-9][0-9]*$/;
		return NumeriqueValidator.validateNumberRegex(formControl, numberRegex);
	}

	/**
	 * Validation que le control est bien un numérique avec 2 décimales
	 *
	 * @param formControl le formcontrol
	 */
	static numeric2Decimal(formControl: AbstractControl) {
		const numberRegex = /^[-+]?([0-9]+[\.,]?)([0-9]){0,2}$/;
		return NumeriqueValidator.validateNumberRegex(formControl, numberRegex);
	}


	/**
	 * Validation que le control est bien un numérique supérieur ou égale à 0 avec 2 décimales
	 *
	 * @param formControl le formcontrol
	 */
	static numeric2DecimalZeroOuPositif(formControl: AbstractControl) {
		const numberRegex = /^([0-9]+[\.,]?)([0-9]){0,2}$/;
		return NumeriqueValidator.validateNumberRegex(formControl, numberRegex);
	}

	/**
	 * Validation que le control est bien un numérique supérieur ou égale à 0 avec 3 décimales
	 *
	 * @param formControl le formcontrol
	 */
	static numeric3DecimalZeroOuPositif(formControl: AbstractControl) {
		const numberRegex = /^([0-9]+[\.,]?)([0-9]){0,3}$/;
		return NumeriqueValidator.validateNumberRegex(formControl, numberRegex);
	}

	/**
	 * Validation que le control est bien un numérique supérieur ou égale à 0 avec n décimales
	 *
	 * @param nombreDecimales le nombre de décimales
	 */
	static numericNDecimalZeroOuPositif(nombreDecimales: number) {
		return (formControl: AbstractControl):{ [key: string]: any } | null => {
			const numberRegex = new RegExp(`^([0-9]+[\.,]?)([0-9]){0,${nombreDecimales}}$`);
			return NumeriqueValidator.validateNumberRegex(formControl, numberRegex);
		};
	}

	/**
	 * Vérifie si le control passé en entrée vérifie la regex numérique indiquée
	 *
	 * @param formControl le control que l'on veut vérifier
	 * @param numberRegex la regex numérique que doit valider le control
	 */
	private static validateNumberRegex(formControl: AbstractControl, numberRegex: RegExp): null | { invalidNumber: boolean } {
		if (!formControl.parent) {
			return null;
		}

		const value = formControl.value;

		if (value === null || typeof value === 'string' && value.trim() === '') {
			return null;
		}

		if (value && !numberRegex.test(value.toString().trim())){
			return { 'invalidNumber': true };
		}

		return null;
	}
}
